module.exports = __webpack_public_path__ + "img/diashow (8).7088448.jpg";